import {Divider, Grid2, Typography} from "@mui/material";
import * as React from "react";
import {ComponentType, SVGProps} from "react";
import {BulletWhiteSvg} from "@/pages/landing-page/utils/Svgs";
import {SvgCrossfade} from "@/pages/landing-page/utils/SvgCrossfade";
import {compactValue} from "@/lib/screen-class";
import {LANDING_SLIDE_TITLE} from "@/pages/landing-page/utils/landing-font-sizes";

export interface CooperationSlideProps {
    svgs: ComponentType<SVGProps<SVGSVGElement>>[];
    messages: {
        title: string;
        message: string | string[];
    }[];
    borderColor: string;
}

export const CooperationSlide = ({ svgs, messages, borderColor }: CooperationSlideProps) => {
    const Svg1 = svgs[0];
    const Svg2 = svgs[1];
    const Svg3 = svgs[2];
    return (
        <Grid2
            container
            direction="row"
            paddingTop={1}
            sx={{
                flexWrap: {
                    lg: "nowrap"
                },
                paddingTop: 4
            }}
            spacing={4}
            width="100%"
        >
            {/* Below `md` the illustration takes a full row above the texts and scales down to the width as a
                square; from `md` it keeps its fixed 400 x 400 px. The SVGs scale through their `viewBox`. */}
            <Grid2
                container
                flexGrow={1}
                // flexShrink={1}
                sx={{
                    minWidth: compactValue("auto", "400px"),
                    minHeight: compactValue("auto", "400px"),
                    width: compactValue("100%", "auto"),
                    justifyContent: {
                        xs: "center",
                        lg: "start"
                    },
                    display: compactValue("flex", "unset")
                }}
            >
                <Grid2
                    data-cy="cooperation-illustration"
                    sx={{
                        width: compactValue("min(400px, 100%)", "400px"),
                        minWidth: compactValue("auto", "400px"),
                        height: compactValue("auto", "400px"),
                        minHeight: compactValue("auto", "400px"),
                        aspectRatio: compactValue("1 / 1", "auto")
                    }}
                >
                    <SvgCrossfade>
                        <Svg1 width="100%" height="100%" />
                        <Svg2 width="100%" height="100%" />
                        <Svg3 width="100%" height="100%" />
                    </SvgCrossfade>
                </Grid2>
            </Grid2>
            <Grid2 flexGrow={2} container direction="row" gap={4}>
                {messages.map((item) => (
                    <Grid2 key={item.title} container direction="column" size={{ xs: 12, md: 3.6 }} spacing={1}>
                        <Grid2 paddingBottom={2}>
                            <Typography fontWeight="700" sx={{ fontSize: LANDING_SLIDE_TITLE }}>
                                {item.title}
                            </Typography>
                            <Divider dir="horizontal" sx={{ borderWidth: 2.5, borderColor }} />
                        </Grid2>
                        <Grid2>
                            {Array.isArray(item.message) ? (
                                <Grid2 container direction="column" gap={2}>
                                    {item.message.map((item) => (
                                        <Grid2
                                            key={item}
                                            container
                                            direction="row"
                                            gap={3}
                                            flexWrap="nowrap"
                                            alignItems="center"
                                        >
                                            <Grid2 width={24} maxWidth={24} minWidth={24}>
                                                <BulletWhiteSvg />
                                            </Grid2>
                                            <Grid2>
                                                <Typography fontSize="16px" marginTop={-1}>
                                                    {item}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    ))}
                                </Grid2>
                            ) : (
                                <Typography fontSize="16px">{item.message}</Typography>
                            )}
                        </Grid2>
                    </Grid2>
                ))}
            </Grid2>
        </Grid2>
    );
};
